import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import { TextField } from '@mui/material';

RHFTextField.propTypes = {
  name: PropTypes.string,
};

export default function RHFTextField({ name, mandatory, defaultValue, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          onChange={(event) => {
            if (other.type === 'number') {
              field.onChange(+event.target.value)
            } else {
              field.onChange(event.target.value)
            }
          }}
          fullWidth
          variant="outlined"
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error?.message}
          {...other}
          label={(
            <span>
              {other.label}
              {mandatory && (
                <span style={{ color: 'red' }}> *</span>
              )}
            </span>
          )}
        />
      )}
    />
  );
}
